import { render, staticRenderFns } from "./CustomerSelectedView.vue?vue&type=template&id=00c1e97a&"
import script from "./CustomerSelectedView.vue?vue&type=script&lang=js&"
export * from "./CustomerSelectedView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports